/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type VolunteerQueryVariables = Types.Exact<{
  where: Types.VolunteerWhereInput;
}>;

export type VolunteerQuery = {
  volunteer: Array<
    Pick<
      Types.Volunteer,
      | "primary_category_name"
      | "min_primary_signups"
      | "volunteer_hours"
      | "event_attendee_id"
    > & {
      event_attendee: {
        user: Pick<Types.User, "id" | "email" | "name">;
        shift_signup?: Types.Maybe<
          Array<
            Pick<Types.ShiftSignup, "checked_in"> & {
              shift: Pick<
                Types.EventActivity,
                "name" | "start_time" | "end_time" | "category"
              >;
            }
          >
        >;
      };
    }
  >;
};

export const VolunteerDocument = gql`
  query Volunteer($where: VolunteerWhereInput!) {
    volunteer(where: $where) {
      primary_category_name
      min_primary_signups
      volunteer_hours
      event_attendee_id
      event_attendee {
        user {
          id
          email
          name
        }
        shift_signup {
          checked_in
          shift {
            name
            start_time
            end_time
            category
          }
        }
      }
    }
  }
`;

/**
 * __useVolunteerQuery__
 *
 * To run a query within a React component, call `useVolunteerQuery` and pass it any options that fit your needs.
 * When your component renders, `useVolunteerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVolunteerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVolunteerQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    VolunteerQuery,
    VolunteerQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<VolunteerQuery, VolunteerQueryVariables>(
    VolunteerDocument,
    baseOptions
  );
}
export function useVolunteerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VolunteerQuery,
    VolunteerQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<VolunteerQuery, VolunteerQueryVariables>(
    VolunteerDocument,
    baseOptions
  );
}
export type VolunteerQueryHookResult = ReturnType<typeof useVolunteerQuery>;
export type VolunteerLazyQueryHookResult = ReturnType<
  typeof useVolunteerLazyQuery
>;
export type VolunteerQueryResult = ApolloReactCommon.QueryResult<
  VolunteerQuery,
  VolunteerQueryVariables
>;
